/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @nx/enforce-module-boundaries */

import { useEffect, useRef, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import axios from 'axios';
import clsx from 'clsx';
import moment from 'moment';

import { CardVertical, InlineMessages, InlineMessagesType, Pagination, Text, Types } from '@marriott/mi-ui-library';

import {
  PhoenixOffersSearchByArea,
  PhoenixOffersSearchByGeolocation,
  phoenixOffersListSearch,
} from '@marriott/mi-offers-graphql';

import { isServer } from '@marriott/mi-apollo-client-utils';

import { useClientEnvVarsStore, usePersistentGlobalStore } from '@marriott/mi-store-utils';

import { IMAGE_CACHE_DOMAIN, INTERNAL_CTA_TYPE } from '../../constants/CommonConstants';

import { shouldUseMockData, useGetBreakpoint } from '../../utils/CommonUtils';

import { getDeepLinkParams, getOffersDateFormatted, getTomorrowDate, processAcceptLang } from '../../utils/OfferUtils';

import { SortByFilterComponent } from './sortByFilter';
import { SkeletonOffersSearchResultsLoader } from './SkeletonOffersSearchResultsLoader';
import { OffersSearchResultsFilter } from './offersSearchResultsFilter/OffersSearchResultsFilter';

import {
  BrandProps,
  OffersSearchResultsCardProps,
  OffersSearchResultsProps,
  availableBrandsType,
} from './OffersSearchResults.types';

import { StyledOffersSearchResults } from './OffersSearchResults.styles';

import {
  buildOffersSearchVariables,
  getSeoFriendlyOffersUrl,
  getDefaultOffersSortBy,
  mapOffersSearchResponse,
  OFFERS_QUERY_PARAM_PAGE,
  resolveOffersSearchMode,
} from './utils';
export const OffersSearchResultsWrapper: React.FC<OffersSearchResultsProps> = props => {
  const { model, acceptLanguage, isAuthorMode, requestId, sessionData } = props;
  const isServerSideData = model?.isServerSideData === true && model?.enableDestinationOfferSSR === true;
  const useDestinationMetaDataPayload = model?.useDestinationMetaDataPayload === true;
  const { envVarsObject } = useClientEnvVarsStore();
  const imageDomain = envVarsObject?.['UXL_IMAGE_CACHE_DOMAIN'] ?? IMAGE_CACHE_DOMAIN;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const updateGlobalData = usePersistentGlobalStore((state: any) => state.updateGlobalData);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const globalData = usePersistentGlobalStore((state: any) => state.globalData);
  const [ariesOffer, setAriesOffer] = useState<any>({});
  const [ariesSearch, setAriesSearch] = useState<any>({});
  const [filtersInitialized, setFiltersInitialized] = useState(false);
  const windowQueryparams =
    !isServer && window.location.search.length
      ? decodeURIComponent(window.location.search.slice(1).replace(/\+/g, ' '))
      : '';
  const sessionQueryParam = sessionData?.cacheData?.data?.AriesCommon?.page_url_query_string ?? '';
  const searchQuery = !isServer && windowQueryparams !== sessionQueryParam ? windowQueryparams : sessionQueryParam;
  const breakpoint = useGetBreakpoint();
  const isMobileViewPort = isServerSideData ? model?.viewPort === 'mobile' : breakpoint === 'mobile';
  const acceptLang = processAcceptLang(acceptLanguage ?? '')?.toLowerCase();
  const subdirectory = props?.subDirectoryVal ?? '';
  const [offerSearchResult, setofferSearchResult] = useState<OffersSearchResultsCardProps[]>();
  const [cardCount, setCardCount] = useState(0);
  const dataLoaded = useRef<boolean>(false);
  const hasInitialised = useRef<boolean>(false);
  const [hasError, setHasError] = useState<boolean>(false);
  const [isDataAvailableNearBy, setIsDataAvailableNearBy] = useState<boolean>(false);
  const [updateCards, setUpdateCards] = useState<boolean>(true);
  const [dataLoaderFlag, setDataLoaderFlag] = useState<boolean>(!isServerSideData);
  const [mockOfferSearchResultUXLMockJson, setMockOfferSearchResultUXLMockJson] = useState<any>({});
  const skipInitialClientFetch = useRef<boolean>(isServerSideData);
  let uxlQuery = phoenixOffersListSearch;
  // brand filter state variables
  const [availableBrands, setAvailableBrands] = useState<availableBrandsType[]>([]); // brands which are cominng as facets from uxl & available for selection
  const [selectedBrands, setSelectedBrands] = useState<BrandProps[]>(ariesOffer?.['selectedBrands'] ?? []); // brands which are selected for filtering of list
  const [brandFacets, setBrandFacets] = useState<string[]>([]);

  //offer category state variables
  const [availableOfferCategory, setAvailableOfferCategory] = useState<availableBrandsType[]>([]); // Offer Category which are cominng as facets from uxl & available for selection
  const [selectedOfferCategory, setSelectedOfferCategory] = useState<BrandProps[]>(
    ariesOffer?.['selectedOfferCategory'] ?? []
  ); // Offer Category which are selected for filtering of list
  const [offerCategory, setOfferCategory] = useState<string[]>([]);

  //offer type state variables
  const [availableOfferType, setAvailableOfferType] = useState<availableBrandsType[]>([]); // Offer type which are cominng as facets from uxl & available for selection
  const [selectedOfferType, setSelectedOfferType] = useState<BrandProps[]>(ariesOffer?.['selectedOfferType'] ?? []); // Offer type which are selected for filtering of list
  const [offerType, setOfferType] = useState<string[]>([]);

  //STATE state variables
  const [availableFilterState, setAvailableFilterState] = useState<availableBrandsType[]>([]); // State filters which are cominng as facets from uxl & available for selection
  const [selectedFilterState, setSelectedFilterState] = useState<BrandProps[]>(
    ariesOffer?.['selectedFilterState'] ?? []
  ); // State filter data which are selected for filtering of list
  const [filterState, setFilterState] = useState<string[]>([]);
  const [cityMatchDataVal, setCityMatchData] = useState<boolean>(true);
  const [cityInDateVal, setCityInDate] = useState<string>('');

  // CITY state variables
  const [availableFilterCity, setAvailableFilterCity] = useState<availableBrandsType[]>([]); // City which are cominng as facets from uxl & available for selection
  const [selectedFilterCity, setSelectedFilterCity] = useState<BrandProps[]>(ariesOffer?.['selectedFilterCity'] ?? []); // City which are selected for filtering of list
  const [filterCity, setFilterCity] = useState<string[]>([]);

  // COUNTRY state variables
  const [availableFilterCountry, setAvailableFilterCountry] = useState<availableBrandsType[]>([]); // Country which are cominng as facets from uxl & available for selection
  const [selectedFilterCountry, setSelectedFilterCountry] = useState<BrandProps[]>(
    ariesOffer?.['selectedFilterCountry'] ?? []
  ); // Country which are selected for filtering of list
  const [filterCountry, setFilterCountry] = useState<string[]>([]);

  // states for dynamic filters
  const [dynamicBrand, setDynamicBrand] = useState<string[]>([]);
  const [dynamicOfferType, setDynamicOfferType] = useState<string[]>([]);
  const [dynamicOfferCategory, setDynamicOfferCategory] = useState<string[]>([]);
  const [dynamicCity, setDynamicCity] = useState<string[]>([]);
  const [dynamicState, setDynamicState] = useState<string[]>([]);
  const [dynamicCountry, setDynamicCountry] = useState<string[]>([]);
  //Taiwan search fix
  const hiddenCountry = typeof window !== 'undefined' ? window.sessionStorage.getItem('offersHiddenCountry') : '';

  const urlParams = new URLSearchParams(searchQuery);
  const deepLinkParams = getDeepLinkParams(urlParams, ariesSearch);
  const resolvedSearchMode = resolveOffersSearchMode(deepLinkParams, {
    useDestinationMetaDataPayload,
    destinationMetaData: model?.destinationMetaData,
  });
  const {
    notEligible = false,
    invalidUser = false,
    invalidDeal = false,
    hasPlaceId = '',
    destinationSearched = null,
    destinationCitySearched = '',
    searchByGeoLoc = false,
    searchBystate = false,
    searchBycountry = false,
    offerIds = [],
    searchByOffersIds = false,
    isEmptyOfferIds = false,
    propertyCodes = [],
    searchByPropertyCodes = false,
    isEmptyPropertyCodes = false,
    searchByStayBasedOfferFlag = false,
    isEmptyStayBasedOfferFlag = false,
  } = resolvedSearchMode;
  uxlQuery = searchByGeoLoc
    ? PhoenixOffersSearchByGeolocation
    : searchBystate || searchBycountry
    ? PhoenixOffersSearchByArea
    : searchByOffersIds ||
      searchByPropertyCodes ||
      searchByStayBasedOfferFlag ||
      isEmptyOfferIds ||
      isEmptyPropertyCodes ||
      isEmptyStayBasedOfferFlag
    ? phoenixOffersListSearch
    : phoenixOffersListSearch;

  const sortOptions = [
    {
      sortByOptionTitle: model?.offersSortbyExpiringsoon,
      sortByOptionCode: 'BOOKING_END_DATE',
    },
    {
      sortByOptionTitle: model?.offersSortbyNew,
      sortByOptionCode: 'BOOKING_START_DATE',
    },
  ];
  if (searchByGeoLoc) {
    sortOptions.unshift({
      sortByOptionTitle: model?.offersSortbyDistance,
      sortByOptionCode: 'OFFER_DISTANCE',
    });
  }
  const [sortBy, setSortBy] = useState(model?.sortByData?.sortBy ?? getDefaultOffersSortBy(resolvedSearchMode));
  useEffect(() => {
    // Skip when SSR provided a server-selected sortBy so we don't override user's persisted choice.
    if (isServerSideData) {
      hasInitialised.current = true;
      return;
    }
    if (searchByGeoLoc && !hasInitialised.current) {
      setSortBy('OFFER_DISTANCE');
      hasInitialised.current = true;
    }
  }, [searchByGeoLoc, isServerSideData]);
  //pagination
  const [currentPage, setCurrentPage] = useState<number>(model?.paginationData?.currentPage ?? 1);
  const [offsetValue, setOffsetValue] = useState<number>(
    ((model?.paginationData?.currentPage ?? 1) - 1) * Number(model?.numberOfResultsPerPage ?? 0)
  );
  const [pageCardCountInfo, setPageCardCountInfo] = useState<string>('');
  const paginationPanelLabel = {
    previous: model?.offersPrevious ?? '',
    next: model?.offersNext ?? '',
  };
  const getDateFormatted = (date: any): string => {
    return date?.format('YYYY/MM/DD') ?? '';
  };

  // Load mock data dynamically for dev and author mode
  const GetMockData = async (isAuthorMode: boolean) => {
    if (shouldUseMockData(isAuthorMode)) {
      const mockData = await import('./__mock__/OfferSearchResult.uxl');
      return mockData.OfferSearchResultUXLMockJson;
    }
    return {};
  };

  // update dates in session for carrying over the dates to offer details page
  if (typeof window !== 'undefined') {
    const queryFromDate =
      acceptLanguage === 'en-GB'
        ? moment(urlParams?.get('fromDate'), 'DD/MM/YYYY').format('MM/DD/YYYY')
        : urlParams?.get('fromDate');
    const queryToDate =
      acceptLanguage === 'en-GB'
        ? moment(urlParams?.get('toDate'), 'DD/MM/YYYY').format('MM/DD/YYYY')
        : urlParams?.get('toDate');
    window.sessionStorage.setItem(
      'OfferSearchDates',
      JSON.stringify({
        startDate: getOffersDateFormatted(moment(urlParams?.has('fromDate') ? queryFromDate : moment(new Date()))),
        endDate: getOffersDateFormatted(moment(urlParams?.has('toDate') ? queryToDate : getTomorrowDate(true))),
      })
    );
  }

  useEffect(() => {
    if (globalData['sessionData'] !== undefined) {
      // Once globalData is available, set ariesOffer and ariesSearch
      const offer = globalData?.['AriesOffer'] || globalData?.['sessionData']?.cacheData?.data?.AriesOffer || {};
      const search =
        globalData?.['AriesSearch']?.searchCriteria?.address ||
        globalData?.['sessionData']?.cacheData?.data?.AriesSearch?.searchCriteria?.address ||
        {};
      setAriesSearch(search);
    }
  }, [globalData['sessionData']]);

  const getVariables = () => {
    const isSsrGeoOrAreaRequest =
      isServerSideData &&
      useDestinationMetaDataPayload &&
      (resolvedSearchMode?.searchByGeoLoc || resolvedSearchMode?.searchBystate || resolvedSearchMode?.searchBycountry);

    const apiUrlParams = isSsrGeoOrAreaRequest ? new URLSearchParams() : new URLSearchParams(urlParams);

    const serverFromDate = model?.serverDateQueryParams?.fromDate;
    const serverToDate = model?.serverDateQueryParams?.toDate;
    if (isServerSideData && serverFromDate) {
      apiUrlParams.set('fromDate', serverFromDate);
    }
    if (isServerSideData && serverToDate) {
      apiUrlParams.set('toDate', serverToDate);
    }

    const effectiveAriesSearchAddress = isSsrGeoOrAreaRequest
      ? {
          latitude: model?.destinationMetaData?.latitude,
          longitude: model?.destinationMetaData?.longitude,
          country: model?.destinationMetaData?.countryCode,
          stateProvince: model?.destinationMetaData?.stateCode,
        }
      : ariesSearch;

    return buildOffersSearchVariables({
      acceptLanguage,
      urlParams: apiUrlParams,
      ariesSearchAddress: effectiveAriesSearchAddress,
      mode: resolvedSearchMode,
      limit: Number(model?.numberOfResultsPerPage ?? 0),
      offset: offsetValue,
      sortBy,
      facets: {
        brandFacets: updateCards ? brandFacets : dynamicBrand,
        offerCategory: updateCards ? offerCategory : dynamicOfferCategory,
        offerType: updateCards ? offerType : dynamicOfferType,
        filterState: updateCards ? filterState : dynamicState,
        filterCity: updateCards ? filterCity : dynamicCity,
        filterCountry: updateCards ? filterCountry : dynamicCountry,
      },
      hiddenCountry: isSsrGeoOrAreaRequest ? '' : hiddenCountry ?? '',
      destinationMetaData: model?.destinationMetaData,
    });
  };

  const processofferResultsdata = (offerResultsdata: any) => {
    dataLoaded.current = true;
    if (!updateCards && offerResultsdata) {
      processUxlData(offerResultsdata);
    } else if (offerResultsdata && !isAuthorMode) {
      setHasError(false);
      processUxlData(offerResultsdata);
    } else {
      setDataLoaderFlag(false);
      setHasError(true);
    }
  };

  const [getOffersSearchResultsdata, { data, loading, error }] = useLazyQuery(uxlQuery, {
    fetchPolicy: 'network-only',
    errorPolicy: 'all',
    onCompleted: processofferResultsdata,
    context: {
      headers: {
        'x-request-id': requestId + '-o-offers-OffersSearchResults',
        'accept-language': acceptLang,
      },
    },
  });

  useEffect(() => {
    if (error) {
      setDataLoaderFlag(loading);
      if (!updateCards && data) {
        processUxlData(data);
        dataLoaded.current = true;
      } else if (data && !isAuthorMode) {
        setHasError(false);
        processUxlData(data);
        dataLoaded.current = true;
      } else if (!dataLoaded.current) {
        setHasError(true);
      }
    }
  }, [data, loading, error, dataLoaded]);

  useEffect(() => {
    if (!filtersInitialized) return;
    if (skipInitialClientFetch.current) {
      skipInitialClientFetch.current = false;
      return;
    }

    if (updateCards) {
      setDataLoaderFlag(true);
      // to load cards in author mode
      if (isAuthorMode) {
        const fetchMockData = async () => {
          const mockData = await GetMockData(isAuthorMode);
          setDataLoaderFlag(false);
          processUxlData(mockData);
          setMockOfferSearchResultUXLMockJson(mockData);
        };
        fetchMockData();
      } else {
        const payload = getVariables();
        getOffersSearchResultsdata({
          variables: payload,
        });
      }
    } else {
      const payload = getVariables();
      getOffersSearchResultsdata({
        variables: payload,
      });
    }
    setOffsetValue(0);
    if (typeof window !== 'undefined') {
      window.sessionStorage.removeItem('offersHiddenCountry');
      window.sessionStorage.removeItem('offersHiddenCountrySuggestion');
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    sortBy,
    brandFacets,
    currentPage,
    offerCategory,
    offerType,
    filterState,
    filterCity,
    filterCountry,
    dynamicBrand,
    dynamicOfferCategory,
    dynamicOfferType,
    dynamicCity,
    dynamicCountry,
    dynamicState,
    mockOfferSearchResultUXLMockJson,
  ]);

  const checkNearByAvailableCity = (uxlCityData: any, cityInData: string) => {
    const isCityMatch =
      destinationCitySearched !== ''
        ? uxlCityData?.filter((item: any) => item?.description === destinationCitySearched).length > 0
        : false;
    setCityMatchData(isCityMatch);
    setCityInDate(cityInData);
  };

  useEffect(() => {
    if (updateCards) {
      setIsDataAvailableNearBy(
        cityMatchDataVal === false && cityInDateVal !== destinationCitySearched && destinationCitySearched !== ''
      );
    }
  }, [cityMatchDataVal, cityInDateVal, updateCards]);

  const processUxlData = (uxlData: any) => {
    const response = isAuthorMode ? mockOfferSearchResultUXLMockJson : uxlData || [];
    const mappedData = mapOffersSearchResponse({
      uxlData: response,
      model,
      imageDomain,
      subdirectory,
    });

    setAvailableBrands(mappedData?.facetsData?.availableBrands ?? []);
    setAvailableOfferCategory(mappedData?.facetsData?.availableOfferCategory ?? []);
    setAvailableOfferType(mappedData?.facetsData?.availableOfferType ?? []);
    setAvailableFilterState(mappedData?.facetsData?.availableFilterState ?? []);
    setAvailableFilterCity(mappedData?.facetsData?.availableFilterCity ?? []);
    checkNearByAvailableCity(mappedData?.facetsData?.availableFilterCity ?? [], mappedData?.cityInData ?? '');
    setAvailableFilterCountry(mappedData?.facetsData?.availableFilterCountry ?? []);

    const cardCount = mappedData?.cardCount ?? 0;
    if (cardCount === 0 || ((isEmptyOfferIds || isEmptyPropertyCodes || isEmptyStayBasedOfferFlag) && cardCount > 0)) {
      setHasError(true);
    }
    if (updateCards) {
      setPageCardCountInfo(getPageCardCountInfo(cardCount));
    }
    setCardCount(cardCount);
    setDataLoaderFlag(false);
    if (updateCards) {
      setofferSearchResult(mappedData?.offerCards ?? []);
    }
  };
  const handleSortBy = (event: any, sortOption: string): void => {
    setDataLoaderFlag(true);
    if (event.key === 'Enter' || event.type === 'click' || event.keyCode === 13) {
      updateSortByInSession(sortOption);
      setSortBy(sortOption);
      setCurrentPage(1);
    }
  };
  //update session with selected filters
  const updateSessionObj = async (ariesOffer: any = {}, ariesSearch: any = {}) => {
    const sessionToken = sessionData?.sessionToken;
    try {
      const url = '/mi/phoenix-gateway/session';
      const headers = {
        Cookie: `sessionID=${sessionToken}`,
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
      };
      const payload = {
        createOrUpdate: {
          AriesOffer: ariesOffer,
          AriesSearch: ariesSearch,
        },
        remove: [],
        sessionToken: sessionToken,
      };
      await axios
        .patch(url, payload, {
          headers: headers,
        })
        .then((res: any) => {
          return res?.status;
        });
    } catch (error) {
      console.log(`[OSERP] filters update session API Failed:, ${error}`); // eslint-disable-line no-console
    }
  };
  const addFilterStateToSession = (
    selectedBrandsList: any,
    selectedOfferCategoryList: any,
    selectedOfferTypeList: any,
    selectedFilterStateList: any,
    selectedFilterCityList: any,
    selectedFilterCountryList: any
  ) => {
    // let ariesOffer: any = sessionData?.cacheData?.data?.AriesOffer ?? sessionData?.AriesOffer;
    // const ariesSearch: any = sessionData?.cacheData?.data?.AriesSearch ?? sessionData?.AriesSearch;
    let ariesOffer: any =
      globalData?.sessionData?.cacheData?.data?.AriesOffer ??
      sessionData?.cacheData?.data?.AriesOffer ??
      sessionData?.AriesOffer;
    let ariesSearch: any =
      globalData?.sessionData?.cacheData?.data?.AriesSearch ??
      sessionData?.cacheData?.data?.AriesSearch ??
      sessionData?.AriesSearch;
    window.sessionStorage.setItem(
      'mpoOffersFlexibleDates',
      ariesSearch?.searchCriteria?.availabilityRequestVO?.flexibleDate ? 'true' : 'false'
    );

    ariesOffer = {
      ...ariesOffer,
      selectedBrands: selectedBrandsList,
      selectedOfferCategory: selectedOfferCategoryList,
      selectedOfferType: selectedOfferTypeList,
      selectedFilterState: selectedFilterStateList,
      selectedFilterCity: selectedFilterCityList,
      selectedFilterCountry: selectedFilterCountryList,
      searchData: {
        ...ariesOffer?.searchData,
        latitude: ariesSearch?.searchCriteria?.address?.latitude,
        longitude: ariesSearch?.searchCriteria?.address?.longitude,
        stateCode: ariesSearch?.searchCriteria?.address?.stateProvince,
        countryCode: ariesSearch?.searchCriteria?.address?.country,
        flexible: ariesSearch?.searchCriteria?.availabilityRequestVO?.flexibleDate ? 'on' : '',
        address: ariesSearch?.searchCriteria?.address?.destination,
      },
    };
    ariesSearch = {
      ...ariesSearch,
      searchCriteria: {
        ...ariesSearch?.searchCriteria,
        address: {
          ...ariesSearch?.searchCriteria?.address,
          destinationType:
            urlParams?.get('destinationAddress.type') ?? ariesSearch?.searchCriteria?.address?.destinationType ?? null,
        },
      },
    };
    let updatedSessionData: any = sessionData;
    updatedSessionData = {
      ...updatedSessionData,
      cacheData: {
        ...updatedSessionData?.cacheData,
        data: {
          ...updatedSessionData?.cacheData?.data,
          AriesOffer: ariesOffer,
          AriesSearch: ariesSearch,
        },
      },
    };
    if (typeof window !== 'undefined') {
      window.sessionStorage.setItem('OffersfilterData', JSON.stringify({ ...ariesOffer }));
    }
    updateGlobalData('sessionData', updatedSessionData);
    updateSessionObj(ariesOffer, ariesSearch);
  };

  const updateSortByInSession = (sortByCode: string) => {
    let sessionAriesOffer: any =
      globalData?.sessionData?.cacheData?.data?.AriesOffer ??
      sessionData?.cacheData?.data?.AriesOffer ??
      sessionData?.AriesOffer ??
      {};
    const sessionAriesSearch: any =
      globalData?.sessionData?.cacheData?.data?.AriesSearch ??
      sessionData?.cacheData?.data?.AriesSearch ??
      sessionData?.AriesSearch ??
      {};

    sessionAriesOffer = {
      ...sessionAriesOffer,
      sortBy: sortByCode,
    };

    let updatedSessionData: any = sessionData;
    updatedSessionData = {
      ...updatedSessionData,
      cacheData: {
        ...updatedSessionData?.cacheData,
        data: {
          ...updatedSessionData?.cacheData?.data,
          AriesOffer: sessionAriesOffer,
          AriesSearch: sessionAriesSearch,
        },
      },
    };

    setAriesOffer(sessionAriesOffer);
    if (typeof window !== 'undefined') {
      window.sessionStorage.setItem('OffersfilterData', JSON.stringify({ ...sessionAriesOffer }));
    }
    updateGlobalData('sessionData', updatedSessionData);
    updateSessionObj(sessionAriesOffer, sessionAriesSearch);
  };

  //on click of apply filter button
  const handleApplyFilter = (
    selectedBrandsList: any,
    selectedOfferCategoryList: any,
    selectedOfferTypeList: any,
    selectedFilterStateList: any,
    selectedFilterCityList: any,
    selectedFilterCountryList: any
  ) => {
    setUpdateCards(true);
    addFilterStateToSession(
      selectedBrandsList,
      selectedOfferCategoryList,
      selectedOfferTypeList,
      selectedFilterStateList,
      selectedFilterCityList,
      selectedFilterCountryList
    );
    setDataLoaderFlag(true);
    setSelectedBrands(selectedBrandsList);
    const brandFacetList = selectedBrandsList?.map((item: any) => item?.code);
    setBrandFacets(brandFacetList);

    setSelectedOfferCategory(selectedOfferCategoryList);
    const offerCategoryFacetList = selectedOfferCategoryList?.map((item: any) => item?.code);
    setOfferCategory(offerCategoryFacetList);

    setSelectedOfferType(selectedOfferTypeList);
    const offerTypeFacetList = selectedOfferTypeList?.map((item: any) => item?.code);
    setOfferType(offerTypeFacetList);

    setSelectedFilterState(selectedFilterStateList);
    const stateFacetList = selectedFilterStateList?.map((item: any) => item?.code);
    setFilterState(stateFacetList);

    setSelectedFilterCity(selectedFilterCityList);
    const cityFacetList = selectedFilterCityList?.map((item: any) => item?.code);
    setFilterCity(cityFacetList);

    setSelectedFilterCountry(selectedFilterCountryList);
    const countryFacetList = selectedFilterCountryList?.map((item: any) => item?.code);
    setFilterCountry(countryFacetList);
    setCurrentPage(1);
  };

  // update filter state onload using session filter data
  useEffect(() => {
    if (isServerSideData) {
      const sessionOffer = model?.sessionFromServer ?? {};
      const preSelectedBrands = sessionOffer?.selectedBrands ?? [];
      const preSelectedOfferCategory = sessionOffer?.selectedOfferCategory ?? [];
      const preSelectedOfferType = sessionOffer?.selectedOfferType ?? [];
      const preSelectedFilterState = sessionOffer?.selectedFilterState ?? [];
      const preSelectedFilterCity = sessionOffer?.selectedFilterCity ?? [];
      const preSelectedFilterCountry = sessionOffer?.selectedFilterCountry ?? [];

      setAriesOffer(sessionOffer);
      setSelectedBrands(preSelectedBrands);
      setSelectedOfferCategory(preSelectedOfferCategory);
      setSelectedOfferType(preSelectedOfferType);
      setSelectedFilterState(preSelectedFilterState);
      setSelectedFilterCity(preSelectedFilterCity);
      setSelectedFilterCountry(preSelectedFilterCountry);
      setBrandFacets(preSelectedBrands?.map((item: any) => item?.code));
      setOfferCategory(preSelectedOfferCategory?.map((item: any) => item?.code));
      setOfferType(preSelectedOfferType?.map((item: any) => item?.code));
      setFilterState(preSelectedFilterState?.map((item: any) => item?.code));
      setFilterCity(preSelectedFilterCity?.map((item: any) => item?.code));
      setFilterCountry(preSelectedFilterCountry?.map((item: any) => item?.code));

      const facetsData = model?.facetsData ?? {};
      setAvailableBrands(facetsData?.availableBrands ?? []);
      setAvailableOfferCategory(facetsData?.availableOfferCategory ?? []);
      setAvailableOfferType(facetsData?.availableOfferType ?? []);
      setAvailableFilterState(facetsData?.availableFilterState ?? []);
      setAvailableFilterCity(facetsData?.availableFilterCity ?? []);
      setAvailableFilterCountry(facetsData?.availableFilterCountry ?? []);

      const serverCards = model?.processedData?.offerCards ?? [];
      const totalCount = model?.paginationData?.totalCount ?? model?.processedData?.cardCount ?? 0;
      setofferSearchResult(serverCards);
      setCardCount(totalCount);
      setHasError(model?.serverApiError === true || totalCount === 0);
      setPageCardCountInfo(getPageCardCountInfo(totalCount));
      setSortBy(sessionOffer?.sortBy ?? model?.sortByData?.sortBy ?? getDefaultOffersSortBy(resolvedSearchMode));
      setCurrentPage(model?.paginationData?.currentPage ?? 1);
      setDataLoaderFlag(false);
      setFiltersInitialized(true);
      return;
    }

    const ariesOffer = JSON.parse(window.sessionStorage.getItem('OffersfilterData') ?? '{}');
    setSortBy(ariesOffer?.sortBy ?? getDefaultOffersSortBy(resolvedSearchMode));
    setAriesOffer(ariesOffer);
    handleApplyFilter(
      ariesOffer?.['selectedBrands'] ?? [],
      ariesOffer?.['selectedOfferCategory'] ?? [],
      ariesOffer?.['selectedOfferType'] ?? [],
      ariesOffer?.['selectedFilterState'] ?? [],
      ariesOffer?.['selectedFilterCity'] ?? [],
      ariesOffer?.['selectedFilterCountry'] ?? []
    );

    setFiltersInitialized(true);
  }, []);

  const handleClearAllFilters = () => {
    setUpdateCards(true);
    setSelectedBrands([]);
    setSelectedOfferCategory([]);
    setSelectedOfferType([]);
    setSelectedFilterState([]);
    setSelectedFilterCity([]);
    setSelectedFilterCountry([]);
    setCurrentPage(1);
  };

  const handleDynamicBrands = (brands: any) => {
    setUpdateCards(false);
    setSelectedBrands(brands);
    const brandFacetList = brands?.map((item: any) => item?.code);
    setDynamicBrand(brandFacetList);
  };
  const handleDynamicOfferType = (offertype: any) => {
    setUpdateCards(false);
    setSelectedOfferType(offertype);
    const offerTypeFacetList = offertype?.map((item: any) => item?.code);
    setDynamicOfferType(offerTypeFacetList);
  };
  const handleDynamicOfferCategory = (category: any) => {
    setUpdateCards(false);
    setSelectedOfferCategory(category);
    const offerCategoryFacetList = category?.map((item: any) => item?.code);
    setDynamicOfferCategory(offerCategoryFacetList);
  };
  const handleDynamicState = (state: any) => {
    setUpdateCards(false);
    setSelectedFilterState(state);
    const stateFacetList = state?.map((item: any) => item?.code);
    setDynamicState(stateFacetList);
  };
  const handleDynamicCity = (city: any) => {
    setUpdateCards(false);
    setSelectedFilterCity(city);
    const cityFacetList = city?.map((item: any) => item?.code);
    setDynamicCity(cityFacetList);
  };
  const handleDynamicCountry = (country: any) => {
    setUpdateCards(false);
    setSelectedFilterCountry(country);
    const countryFacetList = country?.map((item: any) => item?.code);
    setDynamicCountry(countryFacetList);
  };

  // Pagination
  const onPageItemClick = (page: number): void => {
    if (isServer) {
      return;
    }

    if (model?.seoFriendlyPagination) {
      const pageParam = model?.paginationData?.queryParamName ?? OFFERS_QUERY_PARAM_PAGE;
      const baseUrl = isServerSideData ? window.location.href : model?.baseURL ?? window.location.href;
      const targetUrl = getSeoFriendlyOffersUrl({
        baseUrl,
        page,
        sortBy: undefined,
      });
      const normalizedTargetUrl =
        pageParam === OFFERS_QUERY_PARAM_PAGE
          ? targetUrl
          : (() => {
              const overrideUrl = new URL(targetUrl, window.location.origin);
              const pageValue = overrideUrl.searchParams.get(OFFERS_QUERY_PARAM_PAGE);
              overrideUrl.searchParams.delete(OFFERS_QUERY_PARAM_PAGE);
              if (pageValue) {
                overrideUrl.searchParams.set(pageParam, pageValue);
              }
              return `${overrideUrl.pathname}${overrideUrl.search}`;
            })();
      window.location.assign(normalizedTargetUrl);
      return;
    }
    setDataLoaderFlag(true);
    setCurrentPage(page);
    const offset = (page - 1) * model?.numberOfResultsPerPage;
    setOffsetValue(offset);
    window.scrollTo(0, 0);
  };
  const getPageCardCountInfo = (cardsTotalCount: number): string => {
    const total = Math.ceil(cardsTotalCount / model?.numberOfResultsPerPage);
    const start = total === 1 || currentPage === 1 ? 1 : (currentPage - 1) * model?.numberOfResultsPerPage + 1;
    const end =
      total === currentPage || currentPage === cardsTotalCount
        ? cardsTotalCount
        : currentPage * model?.numberOfResultsPerPage;
    const offersLabel = model?.offersLabel;

    const countText =
      cardsTotalCount === 0
        ? ''
        : `${model?.offersShowing} ${start}-${end} ${model?.offersOf} ${cardsTotalCount} ${offersLabel}`;

    return countText;
  };

  const hasAppliedFilter =
    brandFacets?.length > 0 ||
    offerCategory?.length > 0 ||
    offerType?.length > 0 ||
    filterState?.length > 0 ||
    filterCity?.length > 0 ||
    filterCountry?.length > 0;
  const useServerSnapshot = isServerSideData && !filtersInitialized;
  const serverCards = model?.processedData?.offerCards ?? [];
  const serverCardCount = model?.paginationData?.totalCount ?? model?.processedData?.cardCount ?? 0;
  const serverSelectedBrands = model?.sessionFromServer?.selectedBrands ?? [];
  const serverSelectedOfferCategory = model?.sessionFromServer?.selectedOfferCategory ?? [];
  const serverSelectedOfferType = model?.sessionFromServer?.selectedOfferType ?? [];
  const serverSelectedFilterState = model?.sessionFromServer?.selectedFilterState ?? [];
  const serverSelectedFilterCity = model?.sessionFromServer?.selectedFilterCity ?? [];
  const serverSelectedFilterCountry = model?.sessionFromServer?.selectedFilterCountry ?? [];

  const displayedCards = useServerSnapshot ? serverCards : offerSearchResult ?? [];
  const displayedCardCount = useServerSnapshot ? serverCardCount : cardCount;
  const displayedPageCardCountInfo = useServerSnapshot
    ? model?.processedData?.cardCountText ?? getPageCardCountInfo(serverCardCount)
    : pageCardCountInfo;
  const displayedCurrentPage = useServerSnapshot ? model?.paginationData?.currentPage ?? 1 : currentPage;
  const displayedSortBy = useServerSnapshot ? model?.sortByData?.sortBy ?? sortBy : sortBy;
  const displayedSortOptions = useServerSnapshot ? model?.sortByData?.sortOptions ?? sortOptions : sortOptions;
  const displayedHasError = useServerSnapshot ? model?.serverApiError === true || displayedCardCount === 0 : hasError;

  const displayedAriesOffer = useServerSnapshot ? model?.sessionFromServer ?? {} : ariesOffer;
  const displayedSelectedBrands = useServerSnapshot ? serverSelectedBrands : selectedBrands;
  const displayedSelectedOfferCategory = useServerSnapshot ? serverSelectedOfferCategory : selectedOfferCategory;
  const displayedSelectedOfferType = useServerSnapshot ? serverSelectedOfferType : selectedOfferType;
  const displayedSelectedFilterState = useServerSnapshot ? serverSelectedFilterState : selectedFilterState;
  const displayedSelectedFilterCity = useServerSnapshot ? serverSelectedFilterCity : selectedFilterCity;
  const displayedSelectedFilterCountry = useServerSnapshot ? serverSelectedFilterCountry : selectedFilterCountry;

  const displayedAvailableBrands = useServerSnapshot ? model?.facetsData?.availableBrands ?? [] : availableBrands;
  const displayedAvailableOfferCategory = useServerSnapshot
    ? model?.facetsData?.availableOfferCategory ?? []
    : availableOfferCategory;
  const displayedAvailableOfferType = useServerSnapshot
    ? model?.facetsData?.availableOfferType ?? []
    : availableOfferType;
  const displayedAvailableFilterState = useServerSnapshot
    ? model?.facetsData?.availableFilterState ?? []
    : availableFilterState;
  const displayedAvailableFilterCity = useServerSnapshot
    ? model?.facetsData?.availableFilterCity ?? []
    : availableFilterCity;
  const displayedAvailableFilterCountry = useServerSnapshot
    ? model?.facetsData?.availableFilterCountry ?? []
    : availableFilterCountry;

  const displayedHasAppliedFilter = useServerSnapshot
    ? displayedSelectedBrands?.length > 0 ||
      displayedSelectedOfferCategory?.length > 0 ||
      displayedSelectedOfferType?.length > 0 ||
      displayedSelectedFilterState?.length > 0 ||
      displayedSelectedFilterCity?.length > 0 ||
      displayedSelectedFilterCountry?.length > 0
    : hasAppliedFilter;

  const showFilters = displayedCardCount > 0 || (displayedCardCount === 0 && displayedHasAppliedFilter);
  const isValidSearch = searchBystate || searchBycountry || searchByGeoLoc;
  const showOppsError = destinationSearched !== '' && hasPlaceId === '' && !isValidSearch ? true : false;
  return (
    <div>
      <StyledOffersSearchResults>
        {dataLoaderFlag ? (
          <div>
            <SkeletonOffersSearchResultsLoader />
          </div>
        ) : (
          <>
            {/* Show error msg when destination searched is not valid */}
            {showOppsError &&
              !displayedHasError &&
              !isDataAvailableNearBy &&
              !notEligible &&
              !invalidUser &&
              !invalidDeal && (
                <div className="mb-3">
                  <InlineMessages type={InlineMessagesType.Error} title={model?.offersOppsErrorMessage} severity="1" />
                </div>
              )}
            {/* error msg for not eligible user */}
            {notEligible && (
              <div className="mb-3">
                <InlineMessages type={InlineMessagesType.Error} title={model?.offersErrorMessageLabel} severity="1" />
              </div>
            )}
            {/* error msg for invalid user */}
            {invalidUser && (
              <div className="mb-3">
                <InlineMessages type={InlineMessagesType.Error} title={model?.offersInvalidUserMessage} severity="1" />
              </div>
            )}
            {/* error msg for Invalid/Expired offer */}
            {invalidDeal && (
              <div className="mb-3">
                <InlineMessages type={InlineMessagesType.Error} title={model?.offersInvalidErrorMessage} severity="1" />
              </div>
            )}
            {/* Show error msg when UXL response is empty or when UXL call is made with empty OfferIds / PropertyCodes / StayBasedOfferFlag  */}
            {displayedHasError && !notEligible && !invalidUser && !invalidDeal && (
              <div className="mb-3">
                <InlineMessages type={InlineMessagesType.Error} title={model?.errorMessage} severity="1" />
              </div>
            )}
            {/* Show info msg when offers in destination are not found but available in near by destinations  */}
            {!displayedHasError && isDataAvailableNearBy && !notEligible && !invalidUser && !invalidDeal && (
              <div className="mb-3">
                <InlineMessages
                  type={InlineMessagesType.Info}
                  title={model?.offersOserpInfoMessage.replace('{x}', destinationCitySearched)}
                  severity="1"
                />
              </div>
            )}

            {/* to show filters when after applying filters, search does not return data and user has to modify the filters */}
            {showFilters && (
              <div className="offer-search-filter mb-3">
                <OffersSearchResultsFilter
                  ariesOffer={displayedAriesOffer}
                  model={model}
                  handleApplyFilter={handleApplyFilter}
                  handleClearAllFilters={handleClearAllFilters}
                  selectedBrands={displayedSelectedBrands}
                  selectedOfferType={displayedSelectedOfferType}
                  selectedOfferCategory={displayedSelectedOfferCategory}
                  selectedFilterState={displayedSelectedFilterState}
                  selectedFilterCity={displayedSelectedFilterCity}
                  selectedFilterCountry={displayedSelectedFilterCountry}
                  availableOfferCategory={displayedAvailableOfferCategory}
                  availableBrands={displayedAvailableBrands}
                  availableOfferType={displayedAvailableOfferType}
                  availableFilterCity={displayedAvailableFilterCity}
                  availableFilterState={displayedAvailableFilterState}
                  availableFilterCountry={displayedAvailableFilterCountry}
                  brandFacets={brandFacets}
                  offerCategory={offerCategory}
                  offerType={offerType}
                  filterState={filterState}
                  filterCity={filterCity}
                  filterCountry={filterCountry}
                  handleDynamicBrands={handleDynamicBrands}
                  handleDynamicOfferType={handleDynamicOfferType}
                  handleDynamicOfferCategory={handleDynamicOfferCategory}
                  handleDynamicState={handleDynamicState}
                  handleDynamicCity={handleDynamicCity}
                  handleDynamicCountry={handleDynamicCountry}
                  featureFlagLogo={props?.featureFlagLogo}
                />
              </div>
            )}
            {displayedCardCount > 0 && (
              <>
                <div className="sort-by-wrapper mb-1">
                  <div className="page-card-count">
                    <Text
                      element={Types.tags.paragraph}
                      copyText={displayedPageCardCountInfo}
                      fontSize={Types.size.large}
                      customClass={clsx(isMobileViewPort ? 't-font-s' : 't-subtitle-l', 'pb-1', 'mb-0')}
                    />
                  </div>

                  <SortByFilterComponent
                    handleSortBy={handleSortBy}
                    sortOptions={displayedSortOptions}
                    currSortByOption={displayedSortBy}
                    offersSortby={model?.offersSortby}
                  />
                </div>

                <div className="container-wrapper mt-3">
                  {displayedCards?.map((card: OffersSearchResultsCardProps) => (
                    <div className="col-xs-12 col-md-6 col-lg-4 mb-4">
                      <CardVertical
                        {...card?.cardProps}
                        custom_click_track_value={`${model?.id}|${card?.cardId}-${card?.cardProps?.header}|${INTERNAL_CTA_TYPE}`}
                      />
                    </div>
                  ))}
                </div>

                {displayedCardCount && displayedCardCount > model?.numberOfResultsPerPage && (
                  <div className="pagination-container mt-5" data-testid="pagination-panel">
                    <Pagination
                      currentPage={displayedCurrentPage}
                      totalCount={displayedCardCount}
                      pageSize={model?.numberOfResultsPerPage}
                      onPageChange={(page: number): void => onPageItemClick(page)}
                      labels={paginationPanelLabel}
                      seoFriendlyPagination={model?.seoFriendlyPagination}
                      queryParamName={model?.paginationData?.queryParamName ?? 'pg'}
                      baseURL={model?.baseURL}
                    />
                  </div>
                )}
              </>
            )}
          </>
        )}
      </StyledOffersSearchResults>
    </div>
  );
};
export default OffersSearchResultsWrapper;
